export const iconFontAwesomeSpinnersArrowRotateLeft = (
	<i className="fa-solid fa-arrow-rotate-left"></i>
);
